<template>

  <section id="app" class='browser-wrapper'>

    <div class="wrapper container" v-if='!Loading'>

    <aside class='wrapper-aside'>

          <div class='wrapper-padding'>
          <img class='logo-aside' src="dist/assets/logo.png" alt="">
          <h4 v-show="isVisible">Selected filters</h4>
          <ul v-show="isVisible" class='filterChecking'>
            <li v-if="filterForm['refregeration'] !== 'allHidden' ">Refregeration: {{ cleanString(this.filterForm.refregeration) }}</li>
            <li v-if="filterForm['rotor_type'].length">Rotor type: {{ cleanString(this.filterForm["rotor_type"]) }}</li>
            <li v-if="filterForm['voltube'].length">Vol./tube (ml): {{ this.filterForm["voltube"] }}</li>
            <li v-if="filterForm['sumtubesrotors'].length">No. of tubes/rotor: {{ this.filterForm["sumtubesrotors"] }}</li>
            <li v-if="filterForm['max_capacity'].length">Max capacity: {{ this.filterForm["max_capacity"] }}</li>
            <li v-if="filterForm['diameter'].length">Diameter (mm): {{ this.filterForm["diameter"] }}</li>
            <li v-if="filterForm['lengthMM'].length">Length (mm): {{ this.filterForm["lengthMM"] }}</li>
            <li v-if="filterForm['tubetypes'].length">Tube type: {{ this.filterForm["tubetypes"] }}</li>
          </ul>
          <span class='delete-filters' @click="deleteAllFilters">Delete all filters</span>
        </div>

<article class='single-filter'>
          <header @click="minimalizeForm">
          <h4>Refregeration</h4>
          <span  class='minimalize-form arrow up'></span>
        </header>
        <span v-if="filterForm.refregeration != 'allHidden'" class='delete-filters' @click="deleteFilters('refregeration')">Delete filters</span>
              <form>

<div class="form-check">
  <div>
  <input hidden  @click="radioSelect()" v-model="filterForm.refregeration" class="form-check-input" type="radio" name="exampleRadios" id="exampleRadio0" value="allHidden"  checked>
  <label hidden  @click="radioSelect()" class="form-check-label" for="exampleRadios0">
    All Hidden
  </label>
  <input @click="radioSelect()" v-model="filterForm.refregeration" class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="all">
  <label @click="radioSelect()" class="form-check-label" for="exampleRadios1">
    All
  </label>
  </div>
</div>
<div class="form-check">
  <div>
  <input @click="radioSelect()" v-model="filterForm.refregeration" class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="yes " >
  <label @click="radioSelect()" class="form-check-label" for="exampleRadios2">
    Yes 
  </label>
  </div>
</div>
<div class="form-check">
  <div>
  <input @click="radioSelect()" v-model="filterForm.refregeration" class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3" value="no" >
  <label @click="radioSelect()" class="form-check-label" for="exampleRadios3">
    No 
  </label>
  </div>
</div>
      </form>
      </article>

<article class='single-filter'>
        <header @click="minimalizeForm">
          <h4>Rotor type</h4>
          <span class='minimalize-form arrow up'></span>
        </header>
        <span class='delete-filters'  v-if="filterForm.rotor_type.length > 0" @click="deleteFilters('rotor_type')">Delete filters</span>
      <form>
<div class="form-check" >
  <div>
       <label>
   <input :checked="rotorAllHandle" type="checkbox" @click="selectAll('rotor')" value='all' >
All</label>
   </div>
  <div v-for="val in rotorValue" :key="val.index">
 <label>   
  <input :id='val.index' @click="selectFilter('rotor')" v-model="proxyRotor" type="checkbox"  :value="val" >
  
    {{val}} 
  </label>
  
  </div>
 

</div>
      </form>
      </article>

      <article class='single-filter'>
        <header @click="minimalizeForm">
          <h4>Max RPM</h4>
          <span class='minimalize-form arrow up'></span>
        </header>
        
      <form class='number-form'>
        
        <input v-model="filterForm.max_rpm_from" type="number">
        <span>-</span>
        <input v-model="filterForm.max_rpm_to" type="number">

      </form>
      </article>

      <article class='single-filter'>      
        <header @click="minimalizeForm">
          <h4>Max RCF</h4>
          <span  class='minimalize-form arrow up'></span>
        </header>
      <form class='number-form'>
      <input v-model="filterForm.max_rcf_from" type="number">
      <span>-</span>
      <input v-model="filterForm.max_rcf_to" type="number">

      </form>
      </article>


      <article class='single-filter'>
        <header @click="minimalizeForm">
          <h4>Vol./tube (ml)</h4>
          <span  class='minimalize-form arrow up'></span>
        </header>
        <span v-if="filterForm.voltube.length > 0" class='delete-filters' @click="deleteFilters('voltube')">Delete filters</span>

      <form>
  <div>
<div class="form-check" >
    <div>
      <label>
   <input type="checkbox" :checked="voltubeAllHandle" @click="selectAll('voltube')" value='all' >
   All</label>
   </div>
  <div v-for="val in voltubeValues" :key="val.index">
  <label>
  <input @click="selectFilter('voltube')" v-model="proxyVoltube" type="checkbox"  :value="val" >
  
    {{val}} 

  </label>
  </div>
</div>
</div>
      </form>


      </article>

      <article class='single-filter'>
        <header @click="minimalizeForm">
          <h4>No. of tubes/rotor</h4>
          <span  class='minimalize-form arrow up'></span>
        </header>
        <span class='delete-filters' @click="deleteFilters('sumtubesrotors')" v-if="filterForm.sumtubesrotors.length > 0">Delete filters</span>
      <form>
<div class="form-check" >
  <div>
    <label>
    <input type="checkbox" :checked="sumOfTubeAllHandle" @click="selectAll('tubes')" value='all' >
   All</label>
  </div>
  <div v-for="val in sumOfTubes" :key="val.index">
    <label>
    <input @click="selectFilter('tubes')" v-model="proxySumOfTubes" type="checkbox"  :value="val" >
      {{val}} 
    </label>
  </div>
</div>
      </form>
            </article>


      <article class='single-filter'>
        <header @click="minimalizeForm">
          <h4>Max capacity</h4>
          <span  class='minimalize-form arrow up'></span>
        </header>
        <span class='delete-filters' @click="deleteFilters('max_capacity')" v-if="filterForm.max_capacity.length > 0">Delete filters</span>
      <form>
        <div class="form-check" >
          <div>
            <label>
            <input type="checkbox" :checked="maxCapacityAllHandle" @click="selectAll('max-capacity')" value='all' >
            All</label>
          </div>
          <div v-for="val in maxCapacity" :key="val.index">
          <label>
          <input @click="selectFilter('max-capacity')"  v-model="proxyMaxCapacity" type="checkbox"  :value="val" >
            {{val}} 
          </label>
          </div>
        </div>

      </form>
            </article>


      <article class='single-filter'>
        <header @click="minimalizeForm">
          <h4>Diameter (mm)</h4>
          <span  class='minimalize-form arrow up'></span>
        </header>
        <span class='delete-filters' @click="deleteFilters('diameter')" v-if="filterForm.diameter.length > 0">Delete filters</span>
      <form>
                <div class="form-check" >

<div>
<label>
            <input type="checkbox" :checked="diameterAllHandle" @click="selectAll('diameter')" value='all' >
            All</label>

</div>

<div v-for="val in diameterValue" :key="val.index">
<label>
          <input @click="selectFilter('diameter')" v-model="proxyDiameter" type="checkbox"  :value="val" >
          
            {{val}} 
            
          </label>

</div>

        </div>

      </form>
            </article>


      <article class='single-filter'>
        <header>
          <h4>Length (mm)</h4>
          <span @click="minimalizeForm" class='minimalize-form arrow up'></span>
        </header>
        <span class='delete-filters' @click="deleteFilters('lengthMM')"  v-if="filterForm.lengthMM.length > 0" >Delete filters</span>
      <form>

      <div class="form-check">

        <div>
<label>
            <input type="checkbox" :checked="lengthAllHandle" @click="selectAll('length')" value='all' >
            All</label>

</div>
<div  v-for="val in lengthValue" :key="val.index">
          <label>
          <input @click="selectFilter('length')" v-model="proxyLength" type="checkbox"  :value="val" >
          
            {{val}} 
          </label>

</div>
        </div>

      </form>
            </article>


      <article class='single-filter'>
        <header>
          <h4>Tube type</h4>
          <span @click="minimalizeForm" class='minimalize-form arrow up'></span>
        </header>
        <span class='delete-filters' @click="deleteFilters('tubetypes')" v-if="filterForm.tubetypes.length > 0">Delete filters</span>
  <form>
          <div class="form-check" >
            <div>
<label>
            <input type="checkbox" :checked="tubeAllHandle" @click="selectAll('tube-type')" value='all' >
            All</label>

</div>
<div v-for="val in tubeTypes" :key="val.index">
<label>
          <input @click="selectFilter('tube-type')" v-model="proxyTypeOfTubes" type="checkbox"  :value="val" >
          
            {{val}} 
          </label>
</div>
        </div>
  </form>
      </article>

    </aside>


    <main class='wrapper__main' v-if='!Loading'>

          <Products v-if='showProducts == true' :list-data="filteredProducts" :pageNumb="pageNumb"/> 
          <Products v-if='showProducts == false' :list-data="filteredProducts = []"/> 
        </main>

</div>
  </section>
</template>

<script>

//const image2base64 = require('image-to-base64');
var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
import jsPDf from 'jspdf';
import Products from './components/Products';
//import XLSX from 'xlsx';
import axios from 'axios';

export default {
  name: 'ohaus',
  components: {
  Products
  },
    data () {
    return {
      isVisible: false,
      pageNumb: 0,
      msg: 'Trwa ładowanie produktów.',
      countProducts: [],
      showProducts: false,
      Loading: true,
      centrifugeAllHandle: true,
      rotorAllHandle: false,
      rotorAllHandlePlus: true,
      voltubeAllHandle: false,
      voltubeAllHandlePlus: true,
      sumOfTubeAllHandle: false,
      sumOfTubeAllHandlePlus: true,
      maxCapacityAllHandle: false,
      maxCapacityAllHandlePlus: true,
      diameterAllHandle: false,
      diameterAllHandlePlus: true,
      lengthAllHandle: false,
      lengthAllHandlePlus: true,
      tubeAllHandle: false,
      tubeAllHandlePlus: true,
      filterStatus: false,
      allProducts: [],
      centrifugeValue: [],
      rotorValue: [],
      voltubeValues: [],
      sumOfTubes: [],
      maxCapacity: [],
      diameterValue: [],
      lengthValue: [],
      tubeTypes: [],
      filterForm: {
        refregeration: 'allHidden',
        centrifuge_type: [],
        rotor_type: [],
        max_rpm_from: 4000,
        max_rpm_to: 18000,
        max_rcf_from: 1878,
        max_rcf_to: 24325,
        voltube: [],
        sumtubesrotors: [],
        max_capacity: [],
        diameter: [],
        lengthMM: [],
        tubetypes: []
      }
    }
  },
  created(){
      let ohaus = this;
      this.getProducts().then(products => {
      this.allProducts = products;
      
      let uniqueCertifuge = [...new Set(this.allProducts.map((element) => {
        return element['Centrifuge'];
      }))];
      this.centrifugeValue = uniqueCertifuge.sort((a, b) => a - b);
      this.filterForm.centrifuge_type = uniqueCertifuge;
      let uniqueRotor = [...new Set(this.allProducts.map((element) => {
        return element['Rotor Type'];
      }))];
      this.rotorValue = uniqueRotor.sort();

    

    let uniqueVoltube = [...new Set(this.allProducts.map((element) => {
        return String(element['Vol./Tube (ml)']);
      }))];
      this.voltubeValues = uniqueVoltube.sort(collator.compare);


    let uniqueSumTube = [...new Set(this.allProducts.map((element) => {
        return element['No. of tubes/rotor'];
      }))];
      this.sumOfTubes = uniqueSumTube.sort((a, b) => a - b);


    let uniqueMaxCapacity = [...new Set(this.allProducts.map((element) => {
        return element['Max Capacity'];
      }))];
      this.maxCapacity = uniqueMaxCapacity.sort(collator.compare);


    let uniqueDiameter = [...new Set(this.allProducts.map((element) => {
        return element['Diameter (mm)'];
      }))];
      this.diameterValue = uniqueDiameter.sort((a, b) => a - b);


    let singleLength = [...new Set(this.allProducts.map((element) => {
        return String(element['Length (mm)']);
      }))];
      this.lengthValue = singleLength.sort(collator.compare);

    let uniqueTubeType = [...new Set(this.allProducts.map((element) => {
        return element['Tube Type'];
      }))];
      this.tubeTypes = uniqueTubeType.sort();

    
    });
    },
  computed: {
    
    proxyCentrifuge: {
      get() {
        return this.filterForm.centrifuge_type;
      },
      set(value) {
        this.filterForm.centrifuge_type = [...value];
      }
    },

    proxyRotor: {
      get() {
        return this.filterForm.rotor_type;
      },
      set(value) {
        this.filterForm.rotor_type = [...value];
      }
    },

    proxyVoltube: {
      get() {
        return this.filterForm.voltube;
      },
      set(value) {
        this.filterForm.voltube = [...value];
      }
    },
    proxySumOfTubes: {
      get() {
        return this.filterForm.sumtubesrotors;
      },
      set(value) {
        this.filterForm.sumtubesrotors = [...value];
      }
    },
    proxyDiameter: {
      get() {
        return this.filterForm.diameter;
      },
      set(value) {
        this.filterForm.diameter = [...value];
      }
    },
    proxyMaxCapacity: {
      get() {
        return this.filterForm.max_capacity;
      },
      set(value) {
        this.filterForm.max_capacity = [...value];
      }
    },
    proxyLength: {
      get() {
        return this.filterForm.lengthMM;
      },
      set(value) {
        this.filterForm.lengthMM = [...value];
      }
    },
    proxyTypeOfTubes: {
      get() {
        return this.filterForm.tubetypes;
      },
      set(value) {
        this.filterForm.tubetypes = [...value];
      }
    },
    filteredProducts() {
      this.pageNumb = 0;
      return this.allProducts
        .filter(val => {
          if ((this.filterForm.refregeration === 'all') || (this.filterForm.refregeration === 'allHidden')) {  return val; }
          
          return val.Refregeration === this.filterForm.refregeration;
          
          })
        .filter((val) => {
          if(this.filterForm.centrifuge_type)
          return this.filterForm.centrifuge_type.some(type => type == val['Centrifuge']);
        })
        .filter((val) => {
          if(this.rotorAllHandlePlus == true ){
            if(this.filterForm.rotor_type.length > 0){
              return this.filterForm.rotor_type.some(type => type == val['Rotor Type']);
            }
            else{
              return val;              
            }
          }else{
              return val;
          }
        })
        .filter((val) => {
          return this.filterForm.max_rpm_from <= parseInt(val['Max RPM']) && this.filterForm.max_rpm_to >= parseInt(val['Max RPM']) ;
        })
        .filter((val) => {
          return this.filterForm.max_rcf_from <= parseInt(val['Max RCF']) && this.filterForm.max_rcf_to >= parseInt(val['Max RCF']) ;
        })
        .filter((val) => {
          

          if(this.voltubeAllHandlePlus == true ){
            if(this.filterForm.voltube.length > 0){
              return this.filterForm.voltube.some(type => type == val['Vol./Tube (ml)']);
            }
            else{
              return val;              
            }
          }else{
              return val;
          }
        })
        .filter((val) => {
          if(this.sumOfTubeAllHandlePlus == true){
            if(this.filterForm.sumtubesrotors.length > 0){
              return this.filterForm.sumtubesrotors.some(type => type == val['No. of tubes/rotor']);
            }else{
              return val;
            }
          }else{
            return val;
          }
        })
        .filter((val) => {
          if(this.maxCapacityAllHandlePlus == true){
            if(this.filterForm.max_capacity.length > 0){
              return this.filterForm.max_capacity.some(type => type == val['Max Capacity']);
            }else{
              return val;
            }
          }else{
            return val;
          }
        })
        .filter((val) => {
          if(this.diameterAllHandlePlus == true){
            if(this.filterForm.diameter.length > 0){
              return this.filterForm.diameter.some(type => type == val['Diameter (mm)']);
            }else{
              return val;
            }
          }else{
            return val;
          }
        })
        .filter((val) => {
          if(this.lengthAllHandlePlus == true){
            if(this.filterForm.lengthMM.length > 0){
              return this.filterForm.lengthMM.some(type => type == val['Length (mm)']);
            }else{
              return val;
            }
          }else{
            return val;
          }
        })
        .filter((val) => {
          if(this.tubeAllHandlePlus == true){
            if(this.filterForm.tubetypes.length > 0){
              return this.filterForm.tubetypes.some(type => type == val['Tube Type']);
            }else{
              return val;
            }
          }else{
              return val;
            }
        })

    },
  },
  methods: {

    cleanString(str){

      if(typeof str == 'string'){
        return str;
      }else{
        let result = Array.from(str);
 
        return result.join("; ");
      }
    },

    minimalizeForm(){
      
      let formHandler = event.target.parentNode.parentNode;
      formHandler.lastChild.classList.toggle('hideForm');
      event.target.parentNode.lastChild.classList.toggle('down');
    },

    deleteAllFilters(){
        this.filterForm.refregeration = 'allHidden',
        this.filterForm.rotor_type = [],
        this.filterForm.max_rpm_from = 4000,
        this.filterForm.max_rpm_to = 18000,
        this.filterForm.max_rcf_from = 1878,
        this.filterForm.max_rcf_to = 24325,
        this.filterForm.voltube = [],
        this.filterForm.sumtubesrotors = [],
        this.filterForm.max_capacity = [],
        this.filterForm.diameter = [],
        this.filterForm.lengthMM = [],
        this.filterForm.tubetypes = [],
        this.showProducts = false; 
          this.rotorAllHandle = false;
          this.rotorAllHandlePlus = false;
          this.voltubeAllHandle = false;
          this.voltubeAllHandlePlus = false;
          this.sumOfTubeAllHandle = false;           
          this.sumOfTubeAllHandlePlus = false;           
          this.maxCapacityAllHandle = false;
          this.maxCapacityAllHandlePlus = false;
          this.diameterAllHandle = false;
          this.diameterAllHandlePlus = false;
          this.lengthAllHandle = false;
          this.lengthAllHandlePlus = false;
          this.tubeAllHandle = false;
          this.tubeAllHandlePlus = false;
    
    },

    deleteFilters(filterType){
      
      if(
        !this.rotorAllHandlePlus &&
        this.filterForm.refregeration === 'allHidden' &&
        this.voltubeAllHandlePlus
      ){
      }
      
      if(filterType === 'refregeration'){
        return this.filterForm.refregeration = 'allHidden'
      }

      switch(filterType){
        case 'rotor_type':
          {
            this.rotorAllHandle = false;
            this.rotorAllHandlePlus = false;
          }
          break;
        case 'voltube':
        {
            this.voltubeAllHandle = false;
            this.voltubeAllHandlePlus = false;
            break;
        }
        case 'sumOfTubeAllHandle':
      {
          this.sumOfTubeAllHandle = false;           
          this.sumOfTubeAllHandlePlus = false;           
          break;
      }    
        case 'max_capacity':
        {
          this.maxCapacityAllHandle = false;
          this.maxCapacityAllHandlePlus = false;
          break;
        }
          
        case 'diameter':
        {
          this.diameterAllHandle = false;
          this.diameterAllHandlePlus = false;
          break;
        }
          
        case 'lengthMM':
        {
          this.lengthAllHandle = false;
          this.lengthAllHandlePlus = false;
          break;
        }
          
        case 'tubetypes':
        {
          this.tubeAllHandle = false;
          this.tubeAllHandlePlus = false;
          break;
        }

      } 
      

      return this.filterForm[filterType] = [];
    },

    radioSelect(){
      this.showProducts = true;
    },

    onlyUnique(value, index, self) { 
    return self.indexOf(value) === index;
    },

    selectAll(arg){
      
      this.showProducts = true;
      switch(arg){
        case 'centrifuge':
          if(!this.centrifugeAllHandle){
          this.filterForm.centrifuge_type = this.centrifugeValue
          this.centrifugeAllHandle = true;
          }else if(this.centrifugeAllHandle){
            this.filterForm.centrifuge_type = [];
            this.centrifugeAllHandle = true
          }
          break;
        case 'rotor':
          if(!this.rotorAllHandle){
          this.filterForm.rotor_type = this.rotorValue;
          this.rotorAllHandle = true;
          this.rotorAllHandlePlus = true;
          }else if(this.rotorAllHandle){
            this.filterForm.rotor_type = [];
            this.rotorAllHandle = false;
            this.rotorAllHandlePlus = false;
          }
          break;
        case 'voltube':
          if(!this.voltubeAllHandle){
          this.filterForm.voltube = this.voltubeValues;
          this.voltubeAllHandle = true;
          this.voltubeAllHandlePlus = true;
          }else if(this.voltubeAllHandle){
            this.filterForm.voltube = [];
            this.voltubeAllHandle = false;
            this.voltubeAllHandlePlus = false;
          }
          break;
        case 'tubes':
          if(!this.sumOfTubeAllHandle){
          this.filterForm.sumtubesrotors = this.sumOfTubes;
          this.sumOfTubeAllHandle = true;
          this.sumOfTubeAllHandlePlus = true;
          }else if(this.sumOfTubeAllHandle){
          this.filterForm.sumtubesrotors = []
          this.sumOfTubeAllHandle = false;           
          this.sumOfTubeAllHandlePlus = false;           
          }
          break;
        case 'max-capacity':
        if(!this.maxCapacityAllHandle){
          this.filterForm.max_capacity = this.maxCapacity;
          this.maxCapacityAllHandle = true;
          this.maxCapacityAllHandlePlus = true;
        }else if(this.maxCapacityAllHandle){
          this.filterForm.max_capacity = [];
          this.maxCapacityAllHandle = false;
          this.maxCapacityAllHandlePlus = false;
        }
          break;
        case 'diameter':
        if(!this.diameterAllHandle){
          this.filterForm.diameter = this.diameterValue;
          this.diameterAllHandle = true;
          this.diameterAllHandlePlus = true;
        }else if(this.diameterAllHandle){
          this.filterForm.diameter = [];
          this.diameterAllHandle = false;
          this.diameterAllHandlePlus = false;
        }
          break;
        case 'length':
        if(!this.lengthAllHandle){
          this.filterForm.lengthMM = this.lengthValue;
          this.lengthAllHandle = true;
          this.lengthAllHandlePlus = true;
        }else if(this.lengthAllHandle){
          this.filterForm.lengthMM = [];
          this.lengthAllHandle = false;
          this.lengthAllHandlePlus = false;
        }
          break;
        case 'tube-type':
        if(!this.tubeAllHandle){
          this.filterForm.tubetypes = this.tubeTypes;
          this.tubeAllHandle = true;
          this.tubeAllHandlePlus = true;
        }else if(this.tubeAllHandle){
          this.filterForm.tubetypes = [];
          this.tubeAllHandle = false;
          this.tubeAllHandlePlus = false;
        }
          break;
      }
      },

    selectFilter(arg){
      this.showProducts = true;
      switch(arg){
        
        case 'centrifuge':
          if(this.centrifugeAllHandle){
            this.centrifugeAllHandle = false;
          }
          break;

        case 'rotor':
          if(this.rotorAllHandle){
            this.rotorAllHandle = false;
            this.rotorAllHandlePlus = true;
            
          }else{
            this.rotorAllHandlePlus = true;
            
          }
          break;

        case 'voltube':
          if(this.voltubeAllHandle){
            this.voltubeAllHandle = false;
            this.voltubeAllHandlePlus = true;
          }else{
            this.voltubeAllHandlePlus = true;
          }
          break;

        case 'tubes':
          if(this.sumOfTubeAllHandle){
            this.sumOfTubeAllHandle = false;           
            this.sumOfTubeAllHandlePlus = true;          
          }else{
            this.sumOfTubeAllHandlePlus = true;
          }
          break;
        case 'max-capacity':
          if(this.maxCapacityAllHandle){
          this.maxCapacityAllHandle = false;
          this.maxCapacityAllHandlePlus = true;
        }else{
          this.maxCapacityAllHandlePlus = true;
        }
          break;
        case 'diameter':
        if(this.diameterAllHandle){
          this.diameterAllHandle = false;
          this.diameterAllHandlePlus = true;
        }else{
          this.diameterAllHandlePlus = true;
        }
          break;
        case 'length':
          if(this.lengthAllHandle){
          this.lengthAllHandle = false;
          this.lengthAllHandlePlus = true;
        }else{
          this.lengthAllHandlePlus = true;
        }
          break;
        case 'tube-type':
          if(this.tubeAllHandle){
          this.tubeAllHandle = false;
          this.tubeAllHandlePlus = true;
        }else{
          this.tubeAllHandlePlus = true;
        }
          break;
      }
      },

    getProducts(){
      const url = 'api/products.xlsx';

      return axios({
        method: 'GET',
        responseType: 'arraybuffer',
        crossdomain: true,
        url
      }).then(res => {
        const data = Array.from(new Uint8Array(res.data))
          .map(val => String.fromCharCode(val))
          .join('');

        const workbook = XLSX.read(data, {type:'binary'});
        const first_sheet_name = workbook.SheetNames[1];
        const worksheet = workbook.Sheets[first_sheet_name];
        this.Loading = false;
        return XLSX.utils.sheet_to_json(worksheet,{raw:true});
        
      });
    },

    getProductsData(){

      const workbook = XLSX.readFile(("www.ohaus.dkonto.pl/offline/products.xlsx"), {type:'binary'});
      let excelJS = XLSX.utils.sheet_to_json(workbook,{raw:true});
      const first_sheet_name = workbook.SheetNames[1];
      const worksheet = workbook.Sheets[first_sheet_name];
      return XLSX.utils.sheet_to_json(worksheet,{raw:true});
    }

  },

}
</script>




// WEBPACK FOOTER //
// src/App.vue